import type { Asset } from '@schibsted-svp/svp-api-types';
import { ComponentChild } from 'preact';

import type { PlayerContext } from '../../../../types/global';
import { getAssetAccess } from '../../../../utils/player/asset';

import { Upcoming } from './Upcoming';
import { AssetTitleContainer } from './AssetTitleContainer';
import { useConfig } from '../../hooks/ConfigProvider';
import { useTitleOverride } from '../../hooks/useTitleOverride';

export const AccessState = ({
  asset,
  isAssetUpcoming,
  isCountdownActive,
  isMobile,
  label,
  context,
}: {
  asset?: Asset;
  isAssetUpcoming?: boolean;
  isCountdownActive?: boolean;
  isMobile: boolean;
  label?: string | ComponentChild;
  context: PlayerContext;
}) => {
  const { ui = {} } = useConfig();
  const titleOverride = useTitleOverride(asset);
  if (!asset || !isAssetUpcoming) {
    return null;
  }

  const accessLevel = getAssetAccess(asset);

  return (
    <div className="vgp-has-access-state">
      <div className="vgp-has-access-top">
        <Upcoming
          accessLevel={accessLevel}
          isCountdownActive={isCountdownActive}
          isMobile={isMobile}
          label={label}
        />
      </div>
      <div className="vgp-has-access-center" />
      <div className="vgp-has-access-bottom">
        {!ui.hideTitle && (
          <AssetTitleContainer
            asset={asset}
            context={context}
            titleOverride={titleOverride}
          />
        )}
      </div>
    </div>
  );
};
